import { v4 as uuid } from 'uuid'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { useEffect, useState } from 'react'
import { useGlobalState } from '../../hooks/useGlobalState'
import { ACTIONS } from '../../state'


export const Counter = ({ min, max, num, ticket }) => {
   const { dispatch } = useGlobalState()
   const [count, setCount] = useState(num)
   const [msg, setMsg] = useState('')

   useEffect(() => {
      setCount(num)
   }, [num])

   const handleIncrease = () => {
      setMsg('')
      if (count + ticket.increment_by > max) return setMsg('Max amount of tickets')
      for (let i = 0; i < ticket.increment_by; i++) {
         dispatch({ type: ACTIONS.ADD_TICKET, payload: { id: uuid(), type_id: ticket.id, ticket, addOns: [] } })
         setCount(prev => prev + 1);
      }
   }

   const handleDecrease = () => {
      setMsg('')
      if (count === 0) return
      if (count - ticket.increment_by < min) return setMsg('Min amount of tickets')
      for (let i = 0; i < ticket.increment_by; i++) {
         dispatch({ type: ACTIONS.REMOVE_TICKET, payload: { type_id: ticket.id } })
         setCount(prev => prev - 1);
      }
   }

   return (
      <div className='counter' >
         <div>
            <button onClick={handleDecrease}><AiOutlineMinus /></button>
            <h1 >{count}</h1>
            <button onClick={handleIncrease}><AiOutlinePlus /></button>
         </div>
         <h3 className='counter-msg'>{msg}</h3>
      </div>
   )
}
